import { Exclude } from 'class-transformer';

export class JournalEntryParameterDto {
    managementCompanyId: number;
    communityId: number;
    journalEntryId: number;
    clearCache = false;

    // Transient Property
    @Exclude()
    isDuplicateAction: boolean;

    getQueryString(): string {
        const tokens = [];
        if (!!this.managementCompanyId) {
            tokens.push(`managementCompanyId=${this.managementCompanyId}`);
        }
        if (!!this.communityId) {
            tokens.push(`communityId=${this.communityId}`);
        }
        if (!!this.journalEntryId) {
            tokens.push(`journalEntryId=${this.journalEntryId}`);
        }
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
